// extracted by mini-css-extract-plugin
module.exports = {"mediaQueryTablet":"(min-width: 768px)","mediaQueryDesktop":"(min-width: 992px)"};